(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header-banner"]) return;
  try {
    
$(document).ready(function(){
  $('.sliderheader').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-category-men"]) return;
  try {
    
  var url = window.location.href;
  if (url.indexOf("type=women") > -1) {
      $('.merch-cat-filter option[value=women]').attr('selected','selected');
      $('.merch-list').hide();
      $('.merch-women').show();
  } else if (url.indexOf("type=kids") > -1) {
      $('.merch-cat-filter option[value=children]').attr('selected','selected');
      $('.merch-list').hide();
      $('.merch-children').show();
  } else if (url.indexOf("type=hats") > -1) {
      $('.merch-cat-filter option[value=hats]').attr('selected','selected');
      $('.merch-list').hide();
      $('.merch-hats').show();
  } else if (url.indexOf("type=shoes&accessories") > -1) {
      $('.merch-cat-filter option[value=shoes]').attr('selected','selected');
      $('.merch-list').hide();
      $('.merch-shoes').show();
  }
  
  $('.merch-cat-filter').change(function() {
  var val = $(this).val();
    if(val == "women") {
      $('.merch-list').hide();
      $('.merch-women').show();
    } else if(val == "men") {
      $('.merch-list').hide();
      $('.merch-men').show();
    } else if(val == "children") {
      $('.merch-list').hide();
      $('.merch-children').show();
    } else if(val == "hats") {
      $('.merch-list').hide();
      $('.merch-hats').show();
    }  else if(val == "shoes") {
      $('.merch-list').hide();
      $('.merch-shoes').show();
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-product-list"]) return;
  try {
    
  var url = window.location.href;
  // MEN'S MERCH
  if (url.indexOf("merch-men") > -1) {
    if (url.indexOf("type=t-shirts") > -1) {
        $('.mens-merch-cat-filter option[value="mens-tshirts"]').prop('selected', true);
        $('.merch-list').hide();
        $('.mens-tshirts').show();
    } else if (url.indexOf("type=hoodies") > -1) {
        $('.mens-merch-cat-filter option[value="mens-hoodies"]').prop('selected', true);
        $('.merch-list').hide();
        $('.mens-hoodies').show();
    } else if (url.indexOf("type=hats") > -1) {
        $('.mens-merch-cat-filter option[value="mens-hats"]').prop('selected', true);
        $('.merch-list').hide();
        $('.mens-hats').show();
    } else if (url.indexOf("type=jackets") > -1) {
        $('.mens-merch-cat-filter option[value="mens-jackets"]').prop('selected', true);
        $('.merch-list').hide();
        $('.mens-jackets').show();
    } else if (url.indexOf("type=joggers") > -1) {
        $('.mens-merch-cat-filter option[value="mens-joggers"]').prop('selected', true);
        $('.merch-list').hide();
        $('.mens-joggers').show();
    }
  }
  
  
  $('.mens-merch-cat-filter').change(function() {
  var val = $(this).val();
    if(val == "mens-tshirts") {
      $('.merch-list').hide();
      $('.mens-tshirts').show();
    } else if(val == "mens-hoodies") {
      $('.merch-list').hide();
      $('.mens-hoodies').show();
    } else if(val == "mens-hats") {
      $('.merch-list').hide();
      $('.mens-hats').show();
    } else if(val == "mens-jackets") {
      $('.merch-list').hide();
      $('.mens-jackets').show();
    } else if(val == "mens-joggers") {
      $('.merch-list').hide();
      $('.mens-joggers').show();
    } 
  });

  // WOMEN'S MERCH
  if (url.indexOf("merch-women") > -1) {
    if (url.indexOf("type=t-shirts") > -1) {
        $('.womens-merch-cat-filter option[value="womens-tshirts"]').prop('selected', true);
        $('.merch-list').hide();
        $('.womens-tshirts').show();
    } else if (url.indexOf("type=hoodies") > -1) {
        $('.womens-merch-cat-filter option[value="womens-hoodies"]').prop('selected', true);
        $('.merch-list').hide();
        $('.womens-hoodies').show();
    } else if (url.indexOf("type=hats") > -1) {
        $('.womens-merch-cat-filter option[value="womens-hats"]').prop('selected', true);
        $('.merch-list').hide();
        $('.womens-hats').show();
    } else if (url.indexOf("type=jackets") > -1) {
        $('.womens-merch-cat-filter option[value="womens-jackets"]').prop('selected', true);
        $('.merch-list').hide();
        $('.womens-jackets').show();
    } else if (url.indexOf("type=joggers") > -1) {
        $('.womens-merch-cat-filter option[value="womens-joggers"]').prop('selected', true);
        $('.merch-list').hide();
        $('.womens-joggers').show();
    } else if (url.indexOf("type=essential") > -1) {
        $('.womens-merch-cat-filter option[value="womens-essential"]').prop('selected', true);
        $('.merch-list').hide();
        $('.womens-essential').show();
    }
  }
  
  $('.womens-merch-cat-filter').change(function() {
  var val = $(this).val();
    if(val == "womens-tshirts") {
      $('.merch-list').hide();
      $('.womens-tshirts').show();
    } else if(val == "womens-hoodies") {
      $('.merch-list').hide();
      $('.womens-hoodies').show();
    } else if(val == "womens-hats") {
      $('.merch-list').hide();
      $('.womens-hats').show();
    } else if(val == "womens-jackets") {
      $('.merch-list').hide();
      $('.womens-jackets').show();
    } else if(val == "womens-joggers") {
      $('.merch-list').hide();
      $('.womens-joggers').show();
    } else if(val == "womens-essential") {
      $('.merch-list').hide();
      $('.womens-essential').show();
    } 
  });

  
  // KIDS'S MERCH
  if (url.indexOf("merch-kids") > -1) {
    if (url.indexOf("type=t-shirts") > -1) {
        $('.kids-merch-cat-filter option[value="kids-tshirts"]').prop('selected', true);
        $('.merch-list').hide();
        $('.kids-tshirts').show();
    } else if (url.indexOf("type=hoodies") > -1) {
        $('.kids-merch-cat-filter option[value="kids-hoodies"]').prop('selected', true);
        $('.merch-list').hide();
        $('.kids-hoodies').show();
    } else if (url.indexOf("type=hats") > -1) {
        $('.kids-merch-cat-filter option[value="kids-hats"]').prop('selected', true);
        $('.merch-list').hide();
        $('.kids-hats').show();
    } else if (url.indexOf("type=jackets") > -1) {
        $('.kids-merch-cat-filter option[value="kids-jackets"]').prop('selected', true);
        $('.merch-list').hide();
        $('.kids-jackets').show();
    } else if (url.indexOf("type=joggers") > -1) {
        $('.kids-merch-cat-filter option[value="kids-joggers"]').prop('selected', true);
        $('.merch-list').hide();
        $('.kids-joggers').show();
    }
  }

  
  $('.kids-merch-cat-filter').change(function() {
  var val = $(this).val();
    if(val == "kids-tshirts") {
      $('.merch-list').hide();
      $('.kids-tshirts').show();
    } else if(val == "kids-hoodies") {
      $('.merch-list').hide();
      $('.kids-hoodies').show();
    } else if(val == "kids-hats") {
      $('.merch-list').hide();
      $('.kids-hats').show();
    } else if(val == "kids-jackets") {
      $('.merch-list').hide();
      $('.kids-jackets').show();
    } else if(val == "kids-joggers") {
      $('.merch-list').hide();
      $('.kids-joggers').show();
    } 
  });

      // HAT'S MERCH
  if (url.indexOf("merch-hats") > -1) {
    if (url.indexOf("type=bucket-hats") > -1) {
        $('.hats-merch-cat-filter option[value="hats-buckethats"]').prop('selected', true);
        $('.merch-list').hide();
        $('.hats-buckethats').show();
    } else if (url.indexOf("type=trucker-caps") > -1) {
        $('.hats-merch-cat-filter option[value="hats-truckercaps"]').prop('selected', true);
        $('.merch-list').hide();
        $('.hats-truckercaps').show();
    } else if (url.indexOf("type=snap-backs") > -1) {
        $('.hats-merch-cat-filter option[value="hats-snapbacks"]').prop('selected', true);
        $('.merch-list').hide();
        $('.hats-snapbacks').show();
    } else if (url.indexOf("type=beanie") > -1) {
        $('.hats-merch-cat-filter option[value="hats-beanie"]').prop('selected', true);
        $('.merch-list').hide();
        $('.hats-beanie').show();
    } 
  }


  $('.hats-merch-cat-filter').change(function() {
  var val = $(this).val();
    if(val == "hats-buckethats") {
      $('.merch-list').hide();
      $('.hats-buckethats').show();
    } else if(val == "hats-truckercaps") {
      $('.merch-list').hide();
      $('.hats-truckercaps').show();
    } else if(val == "hats-snapbacks") {
      $('.merch-list').hide();
      $('.hats-snapbacks').show();
    } else if(val == "hats-beanie") {
      $('.merch-list').hide();
      $('.hats-beanie').show();
    } 
  });

  
  // SHOES AND ACCESSORIES MERCH
  if (url.indexOf("merch-shoes-and-accessories") > -1) {
    if (url.indexOf("type=shoes") > -1) {
        $('.hats-merch-cat-filter option[value="shoes"]').prop('selected', true);
        $('.merch-list').hide();
        $('.shoes').show();
    } else if (url.indexOf("type=accessories") > -1) {
        $('.hats-merch-cat-filter option[value="accessories"]').prop('selected', true);
        $('.merch-list').hide();
        $('.accessories').show();
    } 
  }
  
  $('.shoes-merch-cat-filter').change(function() {
  var val = $(this).val();
    if(val == "shoes") {
      $('.merch-list').hide();
      $('.shoes').show();
    } else if(val == "accessories") {
      $('.merch-list').hide();
      $('.accessories').show();
    } 
  });
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch"]) return;
  try {
    
  $('.merch-filter').change(function() {
  var val = $(this).val(); ;
    if(val == "women") {
      $('.merch-list').hide();
      $('.merch-women').show();
    } else if(val == "men") {
      $('.merch-list').hide();
      $('.merch-men').show();
    } else if(val == "children") {
      $('.merch-list').hide();
      $('.merch-children').show();
    } else if(val == "hats") {
      $('.merch-list').hide();
      $('.merch-hats').show();
    } else if(val == "bagaccessories") {
      $('.merch-list').hide();
      $('.merch-bags').show();
    } else if(val == "all") {
      $('.merch-list').hide();
      $('.merch-all').show();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
